// extracted by mini-css-extract-plugin
module.exports = {"responsivePage":"Page_responsivePage__fZJgx","pageWrapper":"Page_pageWrapper__sIuGp"};